module.exports = __webpack_public_path__ + "img/suc1.602174d7.png";